class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.custom-select__trigger');
    this.options = this.querySelector('.custom-select__options');
    this.valueInput = this.querySelector('input[name="id"]');
    this.valueDisplay = this.querySelector('.custom-select__value');
    this.optionElements = this.querySelectorAll('.custom-select__option');
    
    this.isOpen = false;
    this.selectedIndex = 0;
    
    this.init();
  }

  init() {
    if (!this.trigger || !this.options) return;
    
    this.setupEventListeners();
    this.setInitialState();
  }

  setupEventListeners() {
    // Trigger click
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggle();
    });

    // Option clicks
    this.optionElements.forEach((option, index) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (option.classList.contains('custom-select__option--unavailable')) return;
        
        this.selectOption(index);
        this.close();
      });

      // Keyboard navigation
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!option.classList.contains('custom-select__option--unavailable')) {
            this.selectOption(index);
            this.close();
          }
        }
      });
    });

    // Keyboard navigation on trigger
    this.trigger.addEventListener('keydown', (e) => {
      switch (e.key) {
        case 'Enter':
        case ' ':
        case 'ArrowDown':
          e.preventDefault();
          this.open();
          this.focusFirstOption();
          break;
        case 'ArrowUp':
          e.preventDefault();
          this.open();
          this.focusLastOption();
          break;
        case 'Escape':
          this.close();
          break;
      }
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.close();
      }
    });

    // Close on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  }

  setInitialState() {
    // Find the initially selected option
    const selectedOption = this.querySelector('.custom-select__option--selected');
    if (selectedOption) {
      this.selectedIndex = Array.from(this.optionElements).indexOf(selectedOption);
    }
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.options.setAttribute('data-open', '');
    
    // Focus the selected option
    this.focusOption(this.selectedIndex);
  }

  close() {
    this.isOpen = false;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.options.removeAttribute('data-open');
    this.trigger.focus();
  }

  selectOption(index) {
    const option = this.optionElements[index];
    if (!option || option.classList.contains('custom-select__option--unavailable')) return;

    // Update selected state
    this.optionElements.forEach(opt => {
      opt.classList.remove('custom-select__option--selected');
      opt.setAttribute('aria-selected', 'false');
    });

    option.classList.add('custom-select__option--selected');
    option.setAttribute('aria-selected', 'true');

    // Update value
    const value = option.getAttribute('data-value');
    const text = option.querySelector('.custom-select__option-text').textContent;
    
    this.valueInput.value = value;
    this.valueDisplay.textContent = text;
    this.selectedIndex = index;

    // Trigger change event for form compatibility
    this.valueInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  focusOption(index) {
    const option = this.optionElements[index];
    if (option) {
      option.focus();
    }
  }

  focusFirstOption() {
    const firstAvailable = Array.from(this.optionElements).find(opt => 
      !opt.classList.contains('custom-select__option--unavailable')
    );
    if (firstAvailable) {
      firstAvailable.focus();
    }
  }

  focusLastOption() {
    const lastAvailable = Array.from(this.optionElements).reverse().find(opt => 
      !opt.classList.contains('custom-select__option--unavailable')
    );
    if (lastAvailable) {
      lastAvailable.focus();
    }
  }
}

// Initialize custom selects
function initCustomSelects() {
  const customSelects = document.querySelectorAll('[data-custom-select]:not([data-initialized])');
  
  customSelects.forEach((select, index) => {

    
    const trigger = select.querySelector('.custom-select__trigger');
    const options = select.querySelector('.custom-select__options');
    const valueInput = select.querySelector('input[name="id"]');
    const valueDisplay = select.querySelector('.custom-select__value');
    const optionElements = select.querySelectorAll('.custom-select__option');
    
    if (!trigger || !options) {
      return;
    }
    
    let isOpen = false;
    let selectedIndex = 0;
    
    // Find initially selected option
    const selectedOption = select.querySelector('.custom-select__option--selected');
    if (selectedOption) {
      selectedIndex = Array.from(optionElements).indexOf(selectedOption);
    }
    
    // Trigger click
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggle();
    });
    
    // Option clicks
    optionElements.forEach((option, index) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (option.classList.contains('custom-select__option--unavailable')) return;
        
        selectOption(index);
        close();
        
        // Handle sort functionality
        if (select.closest('.facet-short')) {
          handleSortChange(select);
        }
      });
    });
    
    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!select.contains(e.target)) {
        close();
      }
    });
    
    function toggle() {
      if (isOpen) {
        close();
      } else {
        open();
      }
    }
    
    function open() {
      isOpen = true;
      trigger.setAttribute('aria-expanded', 'true');
      options.setAttribute('data-open', '');
    }
    
    function close() {
      isOpen = false;
      trigger.setAttribute('aria-expanded', 'false');
      options.removeAttribute('data-open');
    }
    
    function selectOption(index) {
      const option = optionElements[index];
      if (!option || option.classList.contains('custom-select__option--unavailable')) return;

      // Update selected state
      optionElements.forEach(opt => {
        opt.classList.remove('custom-select__option--selected');
        opt.setAttribute('aria-selected', 'false');
      });

      option.classList.add('custom-select__option--selected');
      option.setAttribute('aria-selected', 'true');

      // Update value
      const value = option.getAttribute('data-value');
      const text = option.querySelector('.custom-select__option-text').textContent;
      
      // Update hidden select for form submission
      const hiddenSelect = select.querySelector('select[name="sort_by"]');
      if (hiddenSelect) {
        hiddenSelect.value = value;
        hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // Update value input if it exists (for variant selection)
      if (valueInput) {
        valueInput.value = value;
        valueInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // Update display
      if (valueDisplay) {
        valueDisplay.textContent = text;
      }
      
      selectedIndex = index;
    }
    
    function handleSortChange(selectElement) {
      const hiddenSelect = selectElement.querySelector('select[name="sort_by"]');
      if (hiddenSelect) {
        // Trigger the original facet-short functionality
        hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    
    select.dataset.initialized = 'true';
  });
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initCustomSelects);

// Also initialize immediately in case DOM is already ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomSelects);
} else {
  initCustomSelects();
}

// Watch for dynamic content changes (like after sorting)
const observer = new MutationObserver((mutations) => {
  let shouldReinit = false;
  
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      // Check if any added nodes contain custom selects
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.matches && node.matches('[data-custom-select]')) {
            shouldReinit = true;
          } else if (node.querySelector && node.querySelector('[data-custom-select]')) {
            shouldReinit = true;
          }
        }
      });
    }
  });
  
  if (shouldReinit) {
    // Small delay to ensure DOM is fully updated
    setTimeout(initCustomSelects, 100);
  }
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Also listen for custom events that might indicate content changes
document.addEventListener('facet:updated', initCustomSelects);
document.addEventListener('collection:updated', initCustomSelects);

// Re-initialize on page visibility change (handles back/forward navigation)
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    setTimeout(initCustomSelects, 100);
  }
});

// Re-initialize when the page is fully loaded (handles page reloads)
window.addEventListener('load', () => {
  setTimeout(initCustomSelects, 100);
});

// Specific handling for sort functionality
document.addEventListener('DOMContentLoaded', () => {
  // Check if we're on a collection page and re-initialize sort dropdowns
  if (document.querySelector('#SortByContainer') || document.querySelector('#SortByContainerMobile')) {
    setTimeout(initCustomSelects, 200);
  }
});

// Function to specifically re-initialize sort dropdowns
function reinitSortDropdowns() {
  const sortContainer = document.querySelector('#SortByContainer');
  const mobileSortContainer = document.querySelector('#SortByContainerMobile');
  
  if (sortContainer) {
    const customSelect = sortContainer.querySelector('[data-custom-select]');
    if (customSelect && !customSelect.dataset.initialized) {
      initCustomSelects();
    }
  }
  
  if (mobileSortContainer) {
    const customSelect = mobileSortContainer.querySelector('[data-custom-select]');
    if (customSelect && !customSelect.dataset.initialized) {
      initCustomSelects();
    }
  }
}

// Re-initialize sort dropdowns on various events
document.addEventListener('DOMContentLoaded', reinitSortDropdowns);
window.addEventListener('load', reinitSortDropdowns);
document.addEventListener('facet:updated', reinitSortDropdowns);

// Handle drawer events for mobile sort dropdown
document.addEventListener('drawer:opened', reinitSortDropdowns);
document.addEventListener('drawer:closed', reinitSortDropdowns);

// Also listen for when the facet drawer specifically opens
document.addEventListener('click', (e) => {
  if (e.target.closest('[aria-controls="FacetDrawer"]')) {
    // Small delay to ensure drawer content is loaded
    setTimeout(reinitSortDropdowns, 300);
  }
});
